import React, { useEffect, useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Instrument_Check_Report_Table from "./instrument_check_report_table/Instrument_Check_Report_Table";
import Instrument_Check_Report_Filter from "./instrument_check_report_filter/Instrument_Check_Report_Filter";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCustomerReport,
  GetIntrumentCheckReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { GetAllInstrument } from "../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Instrument_Check_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useState({
    instrument_id: "",
    instrument_name: "",
    end_date: "",
    start_date: "",
  });

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.instrument_check_report.Report,
  );

  const data = useSelector((state) => state.equipment.data_instrument);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAllInstrument({
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page: page,
        // per_page: data?.data.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetIntrumentCheckReport({
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page: 1,
        // per_page: data?.data.per_page,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      await setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Instrument_Check_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Instrument_Check_Report_Table
            data={data}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Instrument Check Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Instrument_Check_Report;
